import { Timestamp } from "@firebase/firestore";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import React from "react";
import { DocumentAgentConversation } from "../store/documentAgentConversationsSlice";

interface ConversationListProps {
  conversations: DocumentAgentConversation[];
  selectedId: string | null;
  onSelect: (conversationId: string | null) => void;
}

export const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  selectedId,
  onSelect,
}) => {
  const [menuAnchor, setMenuAnchor] = React.useState<null | {
    element: HTMLElement;
    conversation: DocumentAgentConversation;
  }>(null);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLButtonElement>,
    conversation: DocumentAgentConversation
  ) => {
    event.stopPropagation();
    setMenuAnchor({ element: event.currentTarget, conversation });
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  console.log("Conversations: ", conversations);
  console.log("Selected ID: ", selectedId);
  return (
    <Box sx={{ width: "100%", height: "100%", maxHeight: "100%" }}>
      <List sx={{ maxHeight: "100%", overflowY: "auto" }}>
        {conversations.map((conv) => (
          <ListItem
            key={conv.id}
            disablePadding
            secondaryAction={
              <IconButton
                edge="end"
                aria-label="conversation options"
                onClick={(e) => handleMenuOpen(e, conv)}
              >
                <MoreVertIcon />
              </IconButton>
            }
          >
            <ListItemButton
              selected={selectedId === conv.id}
              onClick={() => onSelect(conv.id)}
            >
              <ListItemText
                primary={conv.metadata.title || `Conversation ${conv.id}`}
                secondary={(conv.metadata.createdAt as Timestamp | undefined)
                  ?.toDate()
                  .toLocaleString()}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Menu
        anchorEl={menuAnchor?.element}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
      >
        {/* Add menu items for conversation actions (e.g., delete, rename) here */}
        <MenuItem
          onClick={() => {
            // TODO: Implement conversation deletion
            handleMenuClose();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </Box>
  );
};
